import { ThemeOptions } from '@material-ui/core';

export const themeOverwriteNoordhoff: ThemeOptions = {
	palette: {
		primary: {
			light: '#aeccff',
			main: '#2965fb',
			dark: '#2965fb',
			contrastText: '#ffffff'
		},
		secondary: {
			main: '#CF0101'
		}
	},
	typography: {
		htmlFontSize: 10,
		h1: {
			fontWeight: 400,
			fontSize: '3.8rem',
			lineHeight: '4.8rem',
			fontStyle: 'normal'
		},
		h2: {
			fontWeight: 700,
			fontSize: '3.8rem',
			lineHeight: '4.8rem',
			fontStyle: 'normal'
		},
		h3: {
			fontWeight: 700,
			fontSize: '2.8rem',
			lineHeight: '4.8rem',
			fontStyle: 'normal'
		},
		h4: {
			fontWeight: 700,
			fontSize: '2.1rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		h5: {
			fontWeight: 700,
			fontSize: '1.6rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		h6: {
			fontWeight: 700,
			fontSize: '1.4rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		body1: {
			fontWeight: 400,
			fontSize: '1.6rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		body2: {
			fontWeight: 400,
			fontSize: '1.4rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		subtitle1: {
			fontWeight: 700,
			fontSize: '1.4rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		caption: {
			fontWeight: 400,
			fontSize: '1.4rem',
			lineHeight: '2rem',
			fontStyle: 'normal'
		},
		button: {
			fontWeight: 600,
			fontSize: '1.4rem',
			lineHeight: '1.91rem',
			fontStyle: 'normal',
			textTransform: 'none'
		}
	},
	overrides: {
		MuiButton: {
			root: {
				padding: '1.1rem 2.4rem'
			},
			text: {
				padding: '1.1rem 2.4rem'
			},
			outlined: {
				padding: '1.05rem 2.4rem'
			},
			contained: {
				padding: '1.1rem 2.4rem',
				'&:disabled': {
					backgroundColor: '#C6DBFF',
					color: '#ffffff'
				}
			}
		},
		MuiMenuItem: {
			root: {
				padding: '1.4rem 1.6rem',
				paddingTop: '1.4rem',
				paddingBottom: '1.4rem',
				'&:hover, &$selected:hover': {
					backgroundColor: '#f5f9ff'
				},
				'&$selected': {
					backgroundColor: '#f5f9ff'
				}
			}
		},
		MuiTooltip: {
			tooltip: {
				fontSize: '1.2rem',
				fontWeight: 400,
				lineHeight: '1.6rem',
				backgroundColor: '#333333',
				padding: '0.8rem'
			}
		},
		MuiChip: {
			root: {
				borderRadius: '0.4rem',
				backgroundColor: '#f3f3f3',
				fontWeight: 400,
				fontSize: '1.4rem',
				lineHeight: '2.4rem'
			}
		}
	}
};

export const themeOverwritePlantyn: ThemeOptions = {
	palette: {
		primary: {
			light: '#aeccff',
			main: '#2965fb',
			dark: '#2965fb',
			contrastText: '#ffffff'
		},
		secondary: {
			main: '#CF0101'
		}
	},
	typography: {
		htmlFontSize: 10,
		h1: {
			fontWeight: 400,
			fontSize: '3.8rem',
			lineHeight: '4.8rem',
			fontStyle: 'normal'
		},
		h2: {
			fontWeight: 700,
			fontSize: '3.8rem',
			lineHeight: '4.8rem',
			fontStyle: 'normal'
		},
		h3: {
			fontWeight: 700,
			fontSize: '2.8rem',
			lineHeight: '4.8rem',
			fontStyle: 'normal'
		},
		h4: {
			fontWeight: 700,
			fontSize: '2.1rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		h5: {
			fontWeight: 700,
			fontSize: '1.6rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		h6: {
			fontWeight: 700,
			fontSize: '1.4rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		body1: {
			fontWeight: 400,
			fontSize: '1.6rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		body2: {
			fontWeight: 400,
			fontSize: '1.4rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		subtitle1: {
			fontWeight: 700,
			fontSize: '1.4rem',
			lineHeight: '2.4rem',
			fontStyle: 'normal'
		},
		caption: {
			fontWeight: 400,
			fontSize: '1.4rem',
			lineHeight: '2rem',
			fontStyle: 'normal'
		},
		button: {
			fontWeight: 600,
			fontSize: '1.4rem',
			lineHeight: '1.91rem',
			fontStyle: 'normal',
			textTransform: 'none'
		}
	},
	overrides: {
		MuiButton: {
			root: {
				padding: '1.1rem 2.4rem'
			},
			text: {
				padding: '1.1rem 2.4rem'
			},
			outlined: {
				padding: '1.05rem 2.4rem'
			},
			contained: {
				padding: '1.1rem 2.4rem',
				'&:disabled': {
					backgroundColor: '#C6DBFF',
					color: '#ffffff'
				}
			}
		},
		MuiMenuItem: {
			root: {
				padding: '1.4rem 1.6rem',
				paddingTop: '1.4rem',
				paddingBottom: '1.4rem',
				'&:hover, &$selected:hover': {
					backgroundColor: '#f5f9ff'
				},
				'&$selected': {
					backgroundColor: '#f5f9ff'
				}
			}
		},
		MuiTooltip: {
			tooltip: {
				fontSize: '1.2rem',
				fontWeight: 400,
				lineHeight: '1.6rem',
				backgroundColor: '#333333',
				padding: '0.8rem'
			}
		},
		MuiChip: {
			root: {
				borderRadius: '0.4rem',
				backgroundColor: '#f3f3f3',
				fontWeight: 400,
				fontSize: '1.4rem',
				lineHeight: '2.4rem'
			}
		}
	}
};
